module.exports = __webpack_public_path__ + "static/img/out8.54d8cf66.png";